import { cn } from '@/lib/utils';
import { useScrollStore } from '@/stores/scroll';

export const ResponsiveContainer = ({
  children,
  className,
  scrollAwareBorder,
}: {
  children: React.ReactNode;
  className?: string;
  fadeoutTop?: boolean;
  fadeoutBottom?: boolean;
  scrollAwareBorder?: boolean;
}) => {
  const isContentScrolled = useScrollStore((s) => s.isContentScrolled);

  return (
    <div
      className={cn(
        'w-full px-4 md:px-8',
        scrollAwareBorder && 'border-b transition-[border-color] duration-200',
        scrollAwareBorder &&
          (isContentScrolled ? 'border-border' : 'border-transparent'),
        className,
      )}>
      {children}
    </div>
  );
};
